import { Injectable, inject } from '@angular/core';
import { StorageService } from '@uoa/auth';
import { Storage } from '@ionic/storage-angular';

@Injectable({
  providedIn: 'root',
})
export class AppStorageService implements StorageService {
  private readonly provider = inject(Storage);

  private storage: Storage;

  private async getStorage(): Promise<Storage> {
    if (!this.storage) {
      this.storage = await this.provider.create();
    }

    return this.storage;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async getItem<T=any>(key: string): Promise<T | null> {
    return (await this.getStorage()).get(key);
  }

  async setItem(key: string, val: unknown): Promise<void> {
    return (await this.getStorage()).set(key, val);
  }

  removeItem(key: string): void {
    this.getStorage().then(storage => storage.remove(key));
  }
}
